/**
 * Fire Mixpanel + Discord activity for the same product event.
 * Discord goes through POST /api/public/activity; Mixpanel via helpers/mixpanel.
 */

import { trackEvent } from "../../helpers/mixpanel";
import { discordTrack } from "./discordTrack";

/**
 * @param {string} event
 * @param {Record<string, unknown>} [metadata]
 */
export function trackProduct(event, metadata = {}) {
  const meta =
    metadata && typeof metadata === "object" ? metadata : {};
  try {
    trackEvent(event, meta);
  } catch {
    // non-fatal
  }
  try {
    discordTrack(event, meta);
  } catch {
    // non-fatal
  }
}
